export const yesOrNoByBoolean = (value: boolean | null): string => (value ? 'Yes' : 'No');
export const noAdditionalNotes = (value: string | null): string => (value ? value : 'No additional notes');
